import React from 'react';
import { useSetRecoilState } from 'recoil';
import { authState, useApiClient } from '../appState';
import useResetRecoil from '../../hooks/useResetRecoil';

export default function useLogoutHandler(onSuccess?: () => void, onError?: (err: Error) => void): () => void {
  const apiClient = useApiClient();
  const updateAuth = useSetRecoilState(authState);
  const resetRecoil = useResetRecoil();

  return React.useCallback((): void => {
    apiClient.post('/v1/auth/logout', {}).then(
      () => {
        updateAuth(undefined);
        resetRecoil();
        if (onSuccess) onSuccess();
      },
      (err) => {
        if (onError) onError(err);
      },
    );
  }, [apiClient, onError, onSuccess, updateAuth, resetRecoil]);
}
